import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import Modal from "react-modal";
import axios from "axios";
import * as MdIcons from "react-icons/md";
import * as RiIcons from "react-icons/ri";
// import * as IoIcons from "react-icons/io";
import { toast } from "react-toastify";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import "./UserManagement.css";
import {
  FETCH_USER_URL,
  CREATE_USER_URL,
  UPDATE_USER_URL,
  DELETE_USER_URL,
} from "../../api/apiRoutes";
Modal.setAppElement("#root");

export default function UserManagement() {
  const [isOpenUserModal, setIsOpenUserModal] = useState(false);
  const [isOpentUserDeleteModal, setIsOpentUserDeleteModal] = useState(false);
  const [tableData, setTableData] = useState([]);

  const [isCreatingUser, setIsCreatingUser] = useState(false);
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    phonecountrycode: "",
    email: "",
    password: "",
  });
  const [uid, setUid] = useState("");

  const showToastAlert = (msg, type = "error") => {
    if (type === "error") {
      toast.error(msg, {
        position: "top-center",
      });
    } else if (type === "success") {
      toast.success(msg, {
        position: "top-center",
      });
    }
  };

  const columnDefs = [
    { headerName: "First Name", field: "firstName" },
    { headerName: "Last Name", field: "lastName" },
    { headerName: "Email", field: "email" },
    { headerName: "UID", field: "uid" },
    { headerName: "Company ID", field: "companyId" },
    {
      headerName: "Contact no.",
      field: "phone",
      cellRendererFramework: (params) => {
        const { phonecountrycode: cc, phone } = params.data;
        return (
          <>
            {cc !== null ? (
              <p>
                ({cc}){phone}
              </p>
            ) : (
              <p>{phone}</p>
            )}
          </>
        );
      },
    },
    {
      headerName: "Status",
      field: "status",
      cellRendererFramework: (params) => {
        return params.data.status === "active" ? (
          <p style={{ color: "blue", fontStyle: "bold" }}>
            {params.data.status}
          </p>
        ) : (
          <p style={{ color: "red", fontStyle: "bold" }}>
            {params.data.status}
          </p>
        );
      },
    },
    {
      headerName: "Created on",
      field: "createdOn",
      cellRendererFramework: (params) => {
        const date = params?.data?.createdOn;
        if (!date) return "";
        return <button className="userCreatedBtn">{date}</button>;
      },
    },
    // { headerName: "Country Code", field: "phonecountrycode" },
    {
      headerName: "Role",
      field: "role",
      cellRendererFramework: (params) => {
        return params.data.role === "admin" ? (
          <p style={{ color: "orange" }}>{params.data.role}</p>
        ) : (
          <p style={{ color: "black" }}>{params.data.role}</p>
        );
      },
    },
    {
      headerName: "Action",
      field: "action",
      cellRendererFramework: (params) => (
        <>
          <button
            className="modal-edit btn"
            onClick={() => handleUserEdit(params.data)}
          >
            <MdIcons.MdEdit />
          </button>
          <button
            className="modal-edit btn"
            onClick={() => handleUserDelete(params.data.uid)}
          >
            <MdIcons.MdDelete color="red" />
          </button>
        </>
      ),
    },
  ];

  const handleUserModalOpenClose = () => {
    setIsOpenUserModal(!isOpenUserModal);
  };
  const handleDeleteModalOpenClose = () => {
    setIsOpentUserDeleteModal(!isOpentUserDeleteModal);
  };

  const handleUserEdit = (user) => {
    if (!user) {
      showToastAlert("User not found.");
      return;
    }
    setUser((prevState) => ({
      ...prevState,
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.phone,
      phonecountrycode: user.phonecountrycode,
      email: user.email,
    }));
    setUid(user.uid);
    setIsCreatingUser(false);
    handleUserModalOpenClose();
  };

  const handleUserDelete = (id) => {
    if (!id) {
      showToastAlert("User ID not found.");
      return;
    }
    setUid(id);
    handleDeleteModalOpenClose();
  };

  const handleModalClose = () => {
    setIsOpenUserModal(!isOpenUserModal);
    setIsCreatingUser(false);
    setUser({
      firstName: "",
      lastName: "",
      phone: "",
      phonecountrycode: "",
      email: "",
      password: "",
    });
  };

  const handleChange = (e) => {
    setUser((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onFilterTextChange = (e) => {};

  const isNumber = (value) => {
    if (!isNaN(value)) {
      return value;
    } else {
      // showToastAlert("Country code and Phone number should be integers");
    }
  };
  // Submit Handle for User Create || Update
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!user.firstName || user.firstName.trim() === "") {
        showToastAlert("User's first name is required.");
        return;
      }

      if (!user.lastName || user.lastName.trim() === "") {
        showToastAlert("User's last name is required.");
        return;
      }

      if (!user.phonecountrycode || !isNumber(user.phonecountrycode)) {
        showToastAlert("Phone country code must be a valid number.");
        return;
      }

      if (!user.phone || !isNumber(user.phone)) {
        showToastAlert("Phone number must be a valid number.");
        return;
      }

      const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
      if (!user.email || !emailRegex.test(user.email)) {
        showToastAlert("Please enter a valid email address.");
        return;
      }

      if (
        isCreatingUser &&
        (!user.password || user.password.trim().length < 8)
      ) {
        showToastAlert("Password must be at least 8 characters long.");
        return;
      }

      const postData = {
        firstName: user.firstName.trim(),
        lastName: user.lastName.trim(),
        phonecountrycode: user.phonecountrycode,
        phone: user.phone,
        email: user.email.trim(),
      };
      if (isCreatingUser) {
        postData.password = user.password;
        await createUser(postData);
      } else {
        await updateUser(postData);
      }
    } catch (error) {
      console.error("Error::handleSubmit :", error);
    }
  };
  // API IMPLEMENTATION:: Create User
  const createUser = async (data) => {
    try {
      const response = await axios.post(CREATE_USER_URL, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage?.getItem("token")}`,
        },
      });
      // console.log("response: ", response.data)
      if (!response.data.isError) {
        handleUserModalOpenClose();
        showToastAlert(response.data.msg, "success");
        window.location.reload();
      } else {
        showToastAlert("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error creating user:", error);
      const errorMessage =
        error.response?.data?.msg || "An unknown error occurred.";
      showToastAlert(`${errorMessage}`);
    }
  };
  // API IMPLEMENTATION:: Update User
  const updateUser = async (data) => {
    try {
      if (!uid) {
        showToastAlert("User ID not found for update.");
        return;
      }
      const response = await axios.post(`${UPDATE_USER_URL}/${uid}`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage?.getItem("token")}`,
        },
      });
      // console.log("response: ", response.data);
      if (!response.data.isError) {
        handleUserModalOpenClose();
        showToastAlert(response.data.msg, "success");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error updating user:", error);
      const errorMessage =
        error.response?.data?.msg || "An unknown error occurred.";
      showToastAlert(`${errorMessage}`);
    }
  };
  // API IMPLEMENTATION:: Delete Company
  const deleteUser = async () => {
    try {
      if (!uid) {
        showToastAlert("User ID not found for delete.");
        return;
      }
      const response = await axios.post(
        `${DELETE_USER_URL}/${uid}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage?.getItem("token")}`,
          },
        }
      );
      // console.log("response: ", response.data);
      if (!response.data.isError) {
        handleDeleteModalOpenClose();
        showToastAlert(response.data.msg, "success");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      const errorMessage =
        error.response?.data?.msg || "An unknown error occurred.";
      showToastAlert(`${errorMessage}`);
    }
  };

  // API IMPLEMENTATION:: Fetching Users
  const fetchUsers = async () => {
    try {
      // console.log("token: ");
      const response = await axios.post(
        FETCH_USER_URL,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage?.getItem("token")}`,
          },
        }
      );
      // console.log("response: ", response.data.data);
      if (response.data.data) {
        setTableData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  // Useeffect
  useEffect(() => {
    fetchUsers();
  }, []);
  return (
    <>
      <input
        type="text"
        id="user-filter-box"
        placeholder="Search by email"
        onChange={(e) => onFilterTextChange(e)}
      />
      <button
        className="addBtn"
        onClick={() => {
          setIsCreatingUser(true);
          handleUserModalOpenClose();
        }}
      >
        Create User
      </button>

      <div className="user-mgmnt-container">
        <div
          className="ag-theme-alpine"
          style={{
            height: "100%",
            width: "99.9%",
            paddingLeft: "1px",
            borderLeft: "1px solid #babfc7",
            borderRight: "1px solid #babfc7",
          }}
        >
          {!tableData.length ? (
            <div className="data-blank-div">
              <h3 className="data-blank-h3">No data found to display!</h3>
            </div>
          ) : (
            <AgGridReact
              columnDefs={columnDefs}
              rowData={tableData}
              defaultColDef={{ resizable: true, flex: 1 }}
              pagination={true}
              paginationPageSize={25}
              domLayout="autoHeight"
              isInverted={true}
            />
          )}
        </div>
      </div>

      {/* User :: Create || Update */}
      <Modal
        className="register_modal"
        isOpen={isOpenUserModal}
        onRequestClose={handleUserModalOpenClose}
      >
        <form
          action="post"
          className="userFormContainer"
          onSubmit={handleSubmit}
        >
          <h2
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: ".5rem",
            }}
          >
            <RiIcons.RiUserAddFill /> {isCreatingUser ? "Register" : "Update"}{" "}
            User
          </h2>

          <label htmlFor="email">Owner Firstname</label>
          <input
            required
            className="modalInput"
            type="text"
            name="firstName"
            id="firstName"
            value={user.firstName}
            onChange={handleChange}
          />

          <label htmlFor="email">Owner Lastname</label>
          <input
            required
            className="modalInput"
            type="text"
            name="lastName"
            id="lastName"
            value={user.lastName}
            onChange={handleChange}
          />

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
            }}
          >
            <label>Country code and Phone number</label>
            <span
              style={{
                display: "flex",
                gap: ".2rem",
              }}
            >
              <input
                required
                className="cc-modalInput"
                type="text"
                name="phonecountrycode"
                id="cc"
                value={user.phonecountrycode}
                onChange={handleChange}
              />

              <input
                required
                className="modalInput"
                type="text"
                name="phone"
                id="phone"
                value={user.phone}
                onChange={handleChange}
              />
            </span>
          </div>

          <label htmlFor="email">Email</label>
          <input
            required
            className="modalInput"
            type="email"
            name="email"
            id="email"
            value={user.email}
            onChange={handleChange}
            // readOnly={!isCreatingUser}
          />

          {isCreatingUser && (
            <>
              <label htmlFor="password">Password</label>
              <input
                required
                className="modalInput"
                type="password"
                name="password"
                id="password"
                value={user.password}
                onChange={handleChange}
              />
            </>
          )}

          {/* <label className="form-control">
            <input
              type="radio"
              value="user"
              onChange={(e) => setRadio(e.target.value)}
            />
            User
          </label> */}

          {/* <label className="form-control">
            <input
              type="radio"
              value="admin"
              onChange={(e) => setRadio(e.target.value)}
            />
            Admin
          </label> */}

          <span style={{ display: "flex", justifyContent: "space-evenly" }}>
            <input
              type="submit"
              value={isCreatingUser ? "Register" : "Update"}
              className="registerBtn"
            />

            <button
              onClick={() => {
                handleUserModalOpenClose();
                handleModalClose();
              }}
              className="modal-closeBtn"
            >
              Cancel
            </button>
          </span>
        </form>
      </Modal>

      {/* Delete Alert Modal */}
      <Modal
        className="register_modal"
        isOpen={isOpentUserDeleteModal}
        onRequestClose={handleUserModalOpenClose}
      >
        <div className="userFormContainer">
          <h2
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: ".5rem",
            }}
          >
            Are you sure? You want to detele.
          </h2>

          <span
            style={{ display: "flex", justifyContent: "center", gap: "0.5rem" }}
          >
            <button onClick={deleteUser} className="registerBtn">
              Delete
            </button>
            <button
              onClick={handleDeleteModalOpenClose}
              className="modal-closeBtn"
            >
              Cancel
            </button>
          </span>
        </div>
      </Modal>
    </>
  );
}
